import * as FilesApi from '../api/files-api';

import { logError } from 'shared-services/logger-service';

export const checkStorageLimit = totalSize => FilesApi.checkStorageLimit(totalSize)
    .then(({ uploadable }) => {
        if (!uploadable) {
            logError('file-upload', new Error(`Not enough storage from uploadable ${uploadable.toString()} | totalSize: ${totalSize}`))
            // return Promise.resolve();
            throw new Error('Not enough storage');
        }
    })
    .catch(error => {
        logError('file-upload', new Error(`Not enough storage from catch | totalSize: ${totalSize}`))
        // return Promise.resolve();
        throw new Error('Not enough storage');
    });
